import React, { useState } from "react";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import EventsArray2025 from "./EventsArray2025";
import EventsArray2024 from "./EventsArray2024";
import EventsArray2023 from "./EventsArray2023";
import EventsArray2022 from "./EventsArray2022";
import EventsArray2021 from "./EventsArray2021";
import EventsArray2020 from "./EventsArray2020";
import { Container, Row, Col } from "react-bootstrap";
import LeftEvents from "./LeftEvents";

export function HomeEventList({ EventsArray }) {
    return (
        <div>
            <table className="table table-bordered mb-40">
                <tbody>
                    {EventsArray.map((event, index) => (
                        <tr key={index}>
                            <td
                                style={{
                                    textAlign: "left",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                {/* <i
                                    className="icon fal fas fa-caret-right pl-5"
                                    style={{
                                        display: "block",
                                        alignSelf: "flex-start",
                                        marginTop: "0.31lh",
                                    }}
                                /> */}

                                <div className="date" style={{
                                    backgroundColor: "#ff7350",
                                    minWidth: "120px",
                                    maxWidth: "120px",
                                    minHeight: "67px",
                                    maxHeight: "67px",
                                    color: "white",
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontFamily: "Jost, sans-serif",
                                    padding: "0",
                                    margin: "0",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}>
                                    <strong style={{ display: "block", fontSize: "24px", marginTop: "10px" }}>{event.dt}</strong>
                                    {event.my}
                                </div>

                                <a
                                    href={event.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="c-right ml-40"
                                >

                                    <b className={`ml-40 ${event.glow === "yes" ? 'glowing-text' : ''} `} >

                                        {event.title}
                                    </b>
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

function Main() {
    const [activeIndex, setActiveIndex] = useState(0);
    const handleClick = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    }
    const faqData = [
        {
            id: "2025",
            name: "2025 - Events",
            element: <HomeEventList EventsArray={EventsArray2025} />
        },
        {
            id: "2024",
            name: "2024 - Events",
            element: <HomeEventList EventsArray={EventsArray2024} />
        },

        {
            id: "2023",
            name: "2023 - Events",
            element: <HomeEventList EventsArray={EventsArray2023} />
        },
        {
            id: "2022",
            name: "2022 - Events",
            element: <HomeEventList EventsArray={EventsArray2022} />
        },
        {
            id: "2021",
            name: "2021 - Events",
            element: <HomeEventList EventsArray={EventsArray2021} />
        },
        {
            id: "2020",
            name: "2020 - Events",
            element: <HomeEventList EventsArray={EventsArray2020} />
        }
    ]

    return (
        <>
            <Header />
            <Breadcrumb subtitle={"Events List"} title={"Home"} />
            {/* <Breadcrumb title="Home" subtitle="Events List" bgImage="url(/assets/img/BreadCrumCustom/ImageFaculty.jpg)" /> */}
            <section className="project-detail">

                <Container>
                    <div className="section-title center-align mb-50 wow fadeInDown animated"
                        data-animation="fadeInDown" data-delay=".4s">
                        <h5><i className="fal fa-calendar" /> Events</h5>
                        <h2>Events List</h2>
                    </div>



                    <Row>

                        <Col md={4} className="c-left">
                            <LeftEvents activeIndex={5} />
                        </Col>

                        <Col md={8} className="c-left">

                            {/* <div className="c-heading mb-3">
                                <h1>Events</h1>
                            </div> */}

                            <div
                                className="col-lg-12 col-md-12 text-center wow fadeInUp animated"
                                data-animation="fadeInUp"
                                data-delay=".4s"
                            >
                                <div
                                    className="faq-wrap pl-30 wow fadeInUp animated"
                                    data-animation="fadeInUp"
                                    data-delay=".4s"
                                >
                                    <div
                                        className="accordion"
                                        id="accordionExample"
                                    >
                                        {faqData.map((item, index) => (
                                            <div className="card" key={index}>
                                                <div
                                                    className="card-header"
                                                    id={item.id}
                                                >
                                                    <h2 className="mb-0">
                                                        <button
                                                            className={`faq-btn${activeIndex ===
                                                                index
                                                                ? ""
                                                                : " collapsed"
                                                                }`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse${index}`}
                                                            onClick={() =>
                                                                handleClick(index)
                                                            }
                                                        >
                                                            {item.name}
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    id={`collapse${index}`}
                                                    className={`collapse${activeIndex === index
                                                        ? " show"
                                                        : ""
                                                        } lower-content`}
                                                    data-bs-parent="#accordionExample"
                                                >
                                                    <div className="card-body">
                                                        {item.element}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Main;